angular.module('filters').filter('waiverSignedAt', ["$filter", function($filter) {
  return function(waiver) {
    switch (false) {
      case !waiver.prefill_link_expired:
        return 'N/A';
      case waiver.status !== 'prefilled':
        return 'Pending';
      default:
        return $filter('date')(waiver.signed_at);
    }
  };
}]);
